// ======================================================================
// FILE: src/modules/wms/dashboard/components/TodaysCompletionCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Today's Completion Card
// ======================================================================

import React from "react";

export default function TodaysCompletionCard({
    data = {}
}) {

    const percentage = Number(
        data?.percentage || 0
    );

    const completed = Number(
        data?.completed || 0
    );

    const planned = Number(
        data?.planned || 0
    );

    return (
        <div className="card shadow-sm h-100">

            {/* =========================================================
                HEADER
               ========================================================= */}

            <div className="card-header bg-white">

                <h5 className="mb-0">
                    Today's Completion
                </h5>

            </div>


            {/* =========================================================
                BODY
               ========================================================= */}

            <div className="card-body">

                <div className="text-center">

                    {/* =================================================
                        CIRCULAR PROGRESS
                       ================================================= */}

                    <div
                        style={{
                            width: "180px",
                            height: "180px",
                            margin: "0 auto",
                            borderRadius: "50%",

                            background: `conic-gradient(
                                #198754 ${percentage * 3.6}deg,
                                #e9ecef 0deg
                            )`,

                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >

                        <div
                            style={{
                                width: "135px",
                                height: "135px",
                                borderRadius: "50%",
                                background: "#fff",

                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >

                            <h2
                                className="mb-0 fw-bold text-success"
                            >
                                {percentage}%
                            </h2>

                            <small className="text-muted">
                                Completed
                            </small>

                        </div>

                    </div>


                    <hr />


                    {/* =================================================
                        COUNTS
                       ================================================= */}

                    <div className="row text-center">

                        {/* COMPLETED */}

                        <div className="col">

                            <h4 className="mb-0 text-primary">
                                {completed}
                            </h4>

                            <small className="text-muted">
                                Completed
                            </small>

                        </div>


                        {/* PLANNED */}

                        <div className="col">

                            <h4 className="mb-0 text-secondary">
                                {planned}
                            </h4>

                            <small className="text-muted">
                                Planned
                            </small>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}